<template>
  <div class="system">
    <div class="system-first">
      <nav-bar></nav-bar>
    </div>

    <div class="system-second">
      <img class="system-second-back" src="../assets/system-back.png" />
      <div class="system-second-block">
        <div class="system-second-block-title">汇大师Pro · EA 跟单系统</div>
        <div class="system-second-block-text">EA COPYTRADE SYSTEM</div>
      </div>
    </div>

    <div class="system-three">
      <div class="three-img">
        <img src="../assets/remit1.jpg" alt="" />
      </div>
      <!-- <div class="three-button" @click="merchandiseMet(0)">
        <div class="button-img">
          <img src="../assets/system-4.png" alt="" />
        </div>
        <div class="button-title">立即购买</div>
      </div> -->

      <div class="button-list" v-for="(item, index) in 3" :key="index">
        <div class="list-left">
          {{ index == 0 ? 'EA' : index == 1 ? '管' : '专' }}
          <!-- <img
            :src="
              index == 0
                ? require('../assets/system-1.png')
                : index == 1
                ? require('../assets/system-2.png')
                : require('../assets/system-3.png')
            "
            alt=""
          /> -->
        </div>
        <div class="list-right">
          <div class="list-right-title">
            {{
              index == 0
                ? "EA 镜像跟单系统"
                : index == 1
                  ? "交易管理"
                  : "专业版能力"
            }}
          </div>
          <div class="list-right-text">
            {{
              index == 0
                ? "面向个人与团队的多账户镜像交易方案，安装到 Windows 后本地启动服务，浏览器访问 localhost:8080 进入控制台。"
                : index == 1
                  ? "支持主从账户绑定、批量启停、品种映射与参数统一下发；提供实时执行日志与异常告警。"
                  : "多主多从、分组策略、风险阈值（仓位/单笔/日损）与停止跟单策略；可选 API / Webhook 对接现有系统。 "
            }}
          </div>
        </div>
      </div>
    </div>

    <div class="system-fourth">
      <div class="fourth-top">
        <div class="top-list" v-for="(item, index) in 1" :key="index">
          <img class="list-img" src="../assets/remit2.jpg" alt="" />
          <!-- <div class="list-title">
            {{
              index == 0 ? "汇智投三色线模板（M5）" : "汇智投三色线模板（M5）"
            }}
          </div> -->
        </div>
      </div>
      <div class="fourth-center">
        <div class="center-left" v-for="(item, index) in 1" :key="index">
          <div class="left-img">
            <img :src="index == 0
              ? require('../assets/system-4.png')
              : require('../assets/system-6.png')
              " alt="" />
          </div>

          <div class="left-title" @click="merchandiseMet(index)">
            {{ index == 0 ? "查看详情" : "软件下载" }}
          </div>
        </div>
      </div>

      <div class="fourth-center" style="background: #2481d7; margin-top: 10px" @click="installStop">
        <div class="center-left">
          <div class="left-title">产品手册</div>
        </div>
      </div>

      <div class="fourth-bottom">
        <div class="bottom-title">
          多账户镜像 · 跨平台品种映射
        </div>

        <div class="bottom-lint"></div>

        <div class="bottom-block">
          <div class="block-title">亮点：</div>
          <div class="block-text">
            1、多主多从镜像
          </div>
          <div class="block-text">
            2、分组与配额
          </div>
          <div class="block-text">
            3、品种映射统一管理
          </div>
          <div class="block-text">
            4、执行轨迹与异常告警。
          </div>
        </div>
        <div class="bottom-lint"></div>
      </div>
    </div>

    <div class="system-seventh">
      <tab-bar></tab-bar>
    </div>
  </div>
</template>

<script>
import navBar from "../components/nav-bar.vue";
import tabBar from "../components/tab-bar.vue";

import { usergoodlistGet } from "../api/index";

export default {
  components: { navBar, tabBar },
  data() {
    return {
      ///-----------
      page: 1,
      limit: 10,
      easygetObj: {},
    };
  },
  created() {
    this.usergoodlistGetMet();
  },
  mounted() {
    this.backTop();
    window.onload = function () {
      document.addEventListener("touchstart", function (e) {
        if (e.touches.length > 1) {
          e.preventDefault();
        }
      });
      document.addEventListener("gesturestart", function (e) {
        e.preventDefault();
      });
    };
  },
  methods: {
    backTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
    merchandiseMet(index) {
      if (index == 0) {
        this.$router.push({
          path: "/systemParticulars",
          query: {
            id: this.easygetObj.id,
          },
        });
      } else {
        if (localStorage.getItem("info")) {
          let str =
            "https://after.wflike.com/jeecg-boot/" + this.easygetObj.pcUrl;
          window.open(str);
        } else {
          this.$router.push({
            path: "/register",
          });
        }
      }
    },
    usergoodlistGetMet() {
      let params = {
        pageNo: this.page,
        pageSize: this.limit,
        goodTypeId: null,
      };

      usergoodlistGet(params).then((res) => {
        if (res.code == 200) {
          res.result.records.forEach((item, index) => {
            if (item.goodCode == 'A002') {
              this.easygetObj = item
            }
          });
        }
      });
    },

    installStop() {
       window.open('/remit-pro.html', '_blank');
    },
  },
};
</script>

<style lang="less" scoped>
.system {
  .system-first {
    height: 50px;
    width: 100%;
  }

  .system-second {
    width: 100%;
    position: relative;
    height: 128.5px;
    padding-top: 40px;
    box-sizing: border-box;

    .system-second-back {
      position: absolute;
      width: 100%;
      height: 100%;
      object-fit: fill;
      display: flex;
      top: 0;
    }

    .system-second-block {
      height: 37px;
      position: relative;
      text-align: center;

      .system-second-block-title {
        font-size: 27.5px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 600;
        color: #ffffff;
      }

      .system-second-block-text {
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ffffff;
        opacity: 0.3;
        letter-spacing: 1px;
      }
    }
  }

  .system-three {
    background: #fafafa;
    position: relative;
    padding: 0 16px;
    padding-bottom: 35px;
    box-sizing: border-box;

    .three-img {
      margin: 0 auto;
      width: 293.32px;
      height: 177px;

      img {
        width: 100%;
        height: 100%;
        margin-top: -20px;
      }
    }

    .three-button {
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0 auto;
      margin-bottom: 32.5px;
      width: 100%;
      height: 50px;
      background: #f8ab22;
      border-radius: 6px;

      .button-img {
        width: 21px;
        height: 21px;

        img {
          width: 100%;
          height: 100%;
        }
      }

      .button-title {
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 17px;
        color: #ffffff;
        margin-left: 11px;
        letter-spacing: 1px;
      }
    }

    .button-list {
      display: flex;
      margin-bottom: 22px;

      .list-left {
        border-radius: 50%;
        background: #EEF2FF;
        color: #2481d7;
        font-weight: bold;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        width: 50px;
        height: 50px;

        img {
          width: 50px;
          height: 50px;
        }
      }

      .list-right {
        width: 82%;
        text-align: left;
        margin-left: 10px;

        .list-right-title {
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          font-size: 15px;
          color: #333333;
          margin-bottom: 6px;
        }

        .list-right-text {
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 12px;
          color: #666666;
        }
      }
    }
  }

  .system-fourth {
    padding: 32px 16px 0;
    box-sizing: border-box;

    .fourth-top {
      display: flex;
      align-items: center;
      justify-content: center;

      .top-list {
        margin-right: 18px;
        text-align: center;

        .list-img {
          width: 293.32px;
          height: 177px;
        }

        .list-title {
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 12px;
          color: #2481d7;
        }
      }

      .top-list:last-child {
        margin-right: 0;
      }
    }

    .fourth-center {
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0 auto;
      width: 100%;
      height: 50px;
      background: #f8ab22;
      border-radius: 6px;
      margin-top: 27px;

      .center-left {
        display: flex;
        justify-content: center;

        .left-img {
          width: 21px;
          height: 21px;

          img {
            width: 100%;
            height: 100%;
          }
        }

        .left-title {
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 17px;
          color: #ffffff;
          margin-left: 11px;
          letter-spacing: 1px;
        }
      }

      // .center-left,
      // .center-right {
      //   width: 150px;
      //   height: 45px;
      //   background: #f8ab22;
      //   border-radius: 5px;
      //   display: flex;
      //   justify-content: center;
      //   align-items: center;

      //   .left-img {
      //     width: 16px;
      //     height: 16px;
      //     margin-right: 5px;

      //     img {
      //       width: 100%;
      //       height: 100%;
      //     }
      //   }

      //   .left-title {
      //     font-family: PingFangSC, PingFang SC;
      //     font-weight: 500;
      //     font-size: 15px;
      //     color: #ffffff;
      //   }
      // }

      // .center-left:last-child {
      //   margin-left: 21px;
      //   background: linear-gradient(90deg, #609ce6 0%, #5084da 100%);
      // }
    }

    .fourth-bottom {
      margin-top: 22.5px;

      .bottom-title {
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 15px;
        text-align: center;
        color: #333333;
      }

      .bottom-lint {
        margin: 22.5px 0;
        width: 100%;
        height: 1px;
        background: #e4e4e4;
      }

      .bottom-block {
        .block-title {
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          font-size: 15px;
          color: #2481d7;
          margin-bottom: 11px;
        }

        .block-text {
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 12px;
          color: #666666;
          margin-bottom: 14px;
          line-height: 20px;
        }
      }
    }
  }

  .system-seventh {
    margin-top: 28px;
  }
}
</style>